export default __webpack_public_path__ + "static/media/sounds/clpl_model_sentence_start_Alyx.mp3";